import React from 'react';
import { useState, useEffect } from 'react';
import { Wheel } from 'react-custom-roulette';
import Swal from 'sweetalert2'
import { handle_wheel_game_spin } from '../../page_action/wheel_game_play';
import { AlertWarning } from '../../app_services/AlertService';
import CustomerCard from './CustomerCard';
import PrizeHistoryList from './PrizeHistoryList';
import { useNavigate } from 'react-router-dom';

const PrizeWheel = ({ userData, custPointblance, initialPrizes, get_item_spin,
    get_point_balance, dataRewardHistory, get_reward_history_custcode }) => {
    const navigate = useNavigate()


    const emptyPrizeStyle = { backgroundColor: '#9CA3AF', textColor: '#FFF' };

    const getGroupedPrizes = (prizes) => {
        return prizes.map(prize => ({
            ...prize,
            totalQuantity: prize.quantity
        }));
    };

    const [prizes, setPrizes] = useState(initialPrizes)

    const [mustSpin, setMustSpin] = useState(false);
    const [prizeNumber, setPrizeNumber] = useState(0);
    const [spinDuration, setSpinDuration] = useState(1.0);

    useEffect(() => {
        // console.log(userData, custPointblance)
    }, [])

    // ข้อมูลสำหรับวงล้อใช้ข้อมูลดิบทั้งหมด
    const wheelData = prizes.map(prize => ({
        id: prize.id,
        option: `${prize.option} `, //(${prize.quantity})
        // style: prize.quantity > 0 ? prize.style : emptyPrizeStyle
        style: prize.style

    }));

    // ข้อมูลที่ group แล้วสำหรับแสดงรายการ
    const groupedPrizes = getGroupedPrizes(prizes);

    const randomFloat = (min = 0.5, max = 0.9) => {
        return Math.random() * (max - min) + min;
    };

    const getRandomSpins = () => {
        return Math.floor(Math.random() * 5) + 5;
    };

    const getAvailablePrizes = () => {
        return prizes.filter(prize => prize.quantity > 0);
    };


    const handleSpinClick = async () => {
        // console.log(res_item)

        if (!mustSpin) {
            // console.log('\n Start HandleSpinClick:');
            let res_get_item = await get_item_spin(setPrizes, true)
            const availablePrizes = getAvailablePrizes();

            // console.log('availablePrizes9999', availablePrizes)

            if (availablePrizes.length === 0) {
                alert('ของรางวัลหมดแล้ว!');
                return;
            }

            // คำนวณน้ำหนักตาม probability
            const totalProbability = availablePrizes.reduce((sum, prize) => sum + prize.probability, 0);
            const weights = availablePrizes.map(prize => prize.probability / totalProbability);

            // สุ่มรางวัล
            const random = Math.random();
            let cumulativeWeight = 0;
            let selectedIndex = 0;

            for (let i = 0; i < weights.length; i++) {
                cumulativeWeight += weights[i];
                if (random <= cumulativeWeight) {
                    selectedIndex = i;
                    break;
                }
            }

            const selectedPrize = availablePrizes[selectedIndex];
            // console.log('\n รางวัลที่ได้ :', `${selectedPrize.code} ${selectedPrize.option} ,${selectedPrize.probability}%`);
            // console.log('เปอร์เซ็นต์ :', prizes.filter(e => e.option === selectedPrize.option && e.quantity > 0)[0].probability);
            // console.log(userData, custPointblance)

            let form_handle = {
                MOBILE: userData.data_main.MOBILE,
                CUSTCODE: custPointblance.CUSTCODE,
                REWARD_TR_ID: selectedPrize.id
            }
            let res_hande = await handle_wheel_game_spin(form_handle, null, false)
            // console.log('res_hande', res_hande.status, res_hande.message)
            if (res_hande.status === '00') {
                AlertWarning(res_hande.message)
                return
            }

            if (res_hande.status === '0') {
                AlertWarning(res_hande.message)
                return
            }
            await get_point_balance()


            // หา index ในวงล้อ
            const wheelIndex = prizes.findIndex(p => p.id === selectedPrize.id);
            setPrizeNumber(wheelIndex);
            setSpinDuration(randomFloat());
            setMustSpin(true);

            // Log probabilities
            // console.log('\nPrize probabilities:');
            // availablePrizes.forEach((prize, i) => {
            //     console.log(`${prize.option}: ${(weights[i] * 100).toFixed(2)}% (${prize.quantity} ชิ้น)`);
            // });

        }
    };



    // const next1HandleSpinClick = async () => {
    //     await get_item_spin(setPrizes)
    //     const availablePrizes = getAvailablePrizes();

    //     if (availablePrizes.length === 0) {
    //         alert('ของรางวัลหมดแล้ว!');
    //         return;
    //     }

    //     // คำนวณน้ำหนักตาม probability
    //     const totalProbability = availablePrizes.reduce((sum, prize) => sum + prize.probability, 0);
    //     const weights = availablePrizes.map(prize => prize.probability / totalProbability);

    //     // สุ่มรางวัล
    //     const random = Math.random();
    //     let cumulativeWeight = 0;
    //     let selectedIndex = 0;

    //     for (let i = 0; i < weights.length; i++) {
    //         cumulativeWeight += weights[i];
    //         if (random <= cumulativeWeight) {
    //             selectedIndex = i;
    //             break;
    //         }
    //     }

    //     const selectedPrize = availablePrizes[selectedIndex];


    //     let form_handle = {
    //         MOBILE: userData.data_main.MOBILE,
    //         CUSTCODE: custPointblance.CUSTCODE,
    //         REWARD_TR_ID: selectedPrize.id
    //     }
    //     let res_hande = await handle_wheel_game_spin(form_handle, null, false)
    //     console.log('next2HandleSpinClick', res_hande.status, res_hande.message)
    //     if (res_hande.status === '00') {
    //         AlertWarning(res_hande.message)
    //         return
    //     }

    //     if (res_hande.status === '0') {
    //         AlertWarning(res_hande.message)
    //         return
    //     }

    //     // หา index ในวงล้อ
    //     const wheelIndex = prizes.findIndex(p => p.id === selectedPrize.id);
    //     setPrizeNumber(wheelIndex);
    //     setSpinDuration(randomFloat());
    //     setMustSpin(true);



    //     // Log probabilities
    //     console.log('\nPrize probabilities:');
    //     availablePrizes.forEach((prize, i) => {
    //         console.log(`${prize.option}: ${(weights[i] * 100).toFixed(2)}% (${prize.quantity} ชิ้น)`);
    //     });


    //     console.log('Next Selected Prize:', selectedPrize);
    //     console.log('Available prizes with quantities:', prizes.filter(e => e.option === selectedPrize.option && e.quantity > 0)[0].probability);
    // };

    // const next2HandleSpinClick = async () => {


    //     await get_item_spin(setPrizes)
    //     const availablePrizes = getAvailablePrizes();

    //     if (availablePrizes.length === 0) {
    //         alert('ของรางวัลหมดแล้ว!');
    //         return;
    //     }

    //     // คำนวณน้ำหนักตาม probability
    //     const totalProbability = availablePrizes.reduce((sum, prize) => sum + prize.probability, 0);
    //     const weights = availablePrizes.map(prize => prize.probability / totalProbability);

    //     // สุ่มรางวัล
    //     const random = Math.random();
    //     let cumulativeWeight = 0;
    //     let selectedIndex = 0;

    //     for (let i = 0; i < weights.length; i++) {
    //         cumulativeWeight += weights[i];
    //         if (random <= cumulativeWeight) {
    //             selectedIndex = i;
    //             break;
    //         }
    //     }

    //     const selectedPrize = availablePrizes[selectedIndex];


    //     let form_handle = {
    //         MOBILE: userData.data_main.MOBILE,
    //         CUSTCODE: custPointblance.CUSTCODE,
    //         REWARD_TR_ID: selectedPrize.id
    //     }
    //     let res_hande = await handle_wheel_game_spin(form_handle, null, false)
    //     console.log('next1HandleSpinClick', res_hande.status, res_hande.message)
    //     if (res_hande.status === '00') {
    //         next1HandleSpinClick()
    //         return
    //     }

    //     if (res_hande.status === '0') {
    //         alert(res_hande.message)
    //         return
    //     }

    //     // หา index ในวงล้อ
    //     const wheelIndex = prizes.findIndex(p => p.id === selectedPrize.id);
    //     setPrizeNumber(wheelIndex);
    //     setSpinDuration(randomFloat());
    //     setMustSpin(true);



    //     // Log probabilities
    //     console.log('\nPrize probabilities:');
    //     availablePrizes.forEach((prize, i) => {
    //         console.log(`${prize.option}: ${(weights[i] * 100).toFixed(2)}% (${prize.quantity} ชิ้น)`);
    //     });


    //     console.log('Next Selected Prize:', selectedPrize);
    //     console.log('Available prizes with quantities:', prizes.filter(e => e.option === selectedPrize.option && e.quantity > 0)[0].probability);
    // };


    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-gray-50  py-3 px-3  bg-fixed"
            style={{
                backgroundImage: 'url("https://www.mkmedical.online:444/image_wheel_game/chinese-newyear.png?123")',
                //  backgroundSize: ' 100%'
                backgroundPosition: 'center',
                backgroundSize: 'cover',

            }}>
            <div className="max-w-6xl mx-auto">
                <div className="relative bg-white  rounded-2xl shadow-xl  md:p-8 bg-opacity-90"
                    style={{
                        //      backgroundImage: 'url("https://www.mkmedical.online:444/image_wheel_game/chinese-newyear.png")'

                    }}>
                    <button
                        onClick={() => navigate('/mk-rewards/home')}
                        className="ml-1 mt-1 bg-orange-500 text-white hover:bg-orange-400  rounded-2xl shadow-xl p-2 "
                    >
                        ← ย้อนกลับ
                    </button>

                    <div className="grid md:grid-cols-12 gap-8 items-start" style={{ marginTop: 0 }}>
                        {/* Prize List - แสดงรายการแบบ group */}
                        <div className="md:col-span-5 order-1 md:order-1">
                            <div className=" rounded-xl p-4 h-full">
                                <div className='text-center center' >
                                    <img src='https://www.mkmedical.online:444/assets/images/logo-border-white.png' width={'100%'} alt='prizes' />
                                </div>
                                {/* <h2 className="text-lg font-bold mb-4 text-center text-gray-700">รายการของรางวัล</h2> */}
                                <div className="space-y-3">
                                    {custPointblance ? <div>
                                        <CustomerCard
                                            customerCode={custPointblance.CUSTCODE}
                                            name={custPointblance.FIRSTNAME}
                                            points={custPointblance.POINT_BALANCE}
                                        />
                                    </div> : null}
                                </div>

                                <div className="hidden sm:block space-y-3 mt-4">
                                    <PrizeHistoryList prizesHistory={dataRewardHistory} />
                                </div>
                            </div>
                        </div>

                        <div className="block sm:hidden md:col-span-5 order-3 md:order-3 md-none">
                            <div className="rounded-xl p-4 h-full">
                                <div className="space-y-3 mt-4">
                                    <PrizeHistoryList prizesHistory={dataRewardHistory} />
                                </div>
                            </div>
                        </div>

                        {/* Wheel Section - แสดงรายการทั้งหมด */}
                        <div className="md:col-span-7 order-2 md:order-2">
                            <div className="flex flex-col items-center space-y-8">
                                <div className="relative">
                                    <Wheel
                                        fontSize={13}
                                        mustStartSpinning={mustSpin}
                                        prizeNumber={prizeNumber}
                                        data={wheelData}
                                        spinDuration={spinDuration}
                                        outerBorderWidth={3}  // ความหนาของเส้นขอบ
                                        outerBorderColor={'#EEEEEE'}  // สีของเส้นขอบ
                                        radiusLineWidth={1}  // ความหนาของเส้นแบ่งช่อง
                                        radiusLineColor={'#FFFFFF'}  // สีของเส้นแบ่งช่อง
                                        // textDistance={55}  // ระยะห่างของข้อความจากศูนย์กลาง
                                        fontWeight={'500'}


                                        pointerProps={{
                                            src: 'https://www.mkmedical.online:444/image_wheel_game/wheel-pointer.png',
                                            // style: { transform: `rotate(50deg)` },
                                        }}
                                        onStopSpinning={async () => {
                                            console.log('\n End HandleSpinClick:');
                                            get_point_balance()
                                            get_reward_history_custcode()
                                            await get_item_spin(setPrizes)
                                            setMustSpin(false);
                                            const wonPrize = prizes[prizeNumber];
                                            Swal.fire({
                                                title: `ยินดีด้วย!`,
                                                html: `คุณได้รับ ${wonPrize.option} <br/>   
                                                <div style="display: flex; justify-content: center; margin-top: 1rem;">
                                                    <img src='https://www.mkmedical.online:444/image_wheel_game/${wonPrize.code}.png' 
                                                            style="max-height: 250px; max-width: 200px; object-fit: contain;" />
                                                </div>`,
                                                icon: ""
                                            }).then(() => {
                                                document.body.style.removeProperty('margin-right');
                                                document.body.style.removeProperty('padding-right');
                                                document.body.style.removeProperty('overflow');
                                            });

                                        }}
                                        disableInitialAnimation={false}
                                    />
                                </div>

                                <div className="flex gap-4 w-full justify-center">
                                    {custPointblance ? <button
                                        onClick={handleSpinClick}
                                        className="px-8 py-3 bg-green-500 text-white rounded-lg font-bold shadow-lg hover:bg-green-600 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed "
                                        disabled={getAvailablePrizes().length === 0 || Number(custPointblance.POINT_BALANCE) === 0}
                                    >
                                        {getAvailablePrizes().length === 0 ? `🎯 SPIN (ของรางวัลหมด)` : `🎯 SPIN`} ({custPointblance.POINT_BALANCE})
                                    </button> : null}

                                    {/* <button
                                        onClick={() => { AlertWarning('รออัพเดทของรางวัล') }}
                                        className="px-8 py-3 bg-green-500 text-white rounded-lg font-bold shadow-lg hover:bg-green-600 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed "
                                        disabled={true}
                                    >
                                        SPIN (รออัพเดทของรางวัล)
                                    </button> */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrizeWheel;